import { unwrapFetchResponse } from "../utils/unwrapApiResponse";
import { errorFromResponse } from "../utils/apiErrors";

// Products, deals and contracts live on the platform API. Only the engine
// endpoints (signals etc.) stay on each product's own API.
export const BASE_URL = "https://poc.mrc.ai/api";

async function getData(url, failure) {
  const response = await fetch(url);
  if (!response.ok) throw await errorFromResponse(response, failure);
  return await unwrapFetchResponse(response);
}

export async function getProducts() {
  const products = await getData(`${BASE_URL}/products`, "Failed to fetch Products");
  return Array.isArray(products) ? products : [];
}

/** The product with this code, or null. GET /products returns them all. */
export async function getProductByCode(code) {
  const products = await getProducts();
  return products.find((p) => p.code === code) || null;
}

export async function getProduct(productId) {
  return getData(`${BASE_URL}/products/${productId}`, "Failed to fetch Product");
}

/** Every deal header (no paging), e.g. for name lookups. */
export async function getDealHeaders() {
  const deals = await getData(`${BASE_URL}/deals/headers`, "Failed to fetch Deals");
  return Array.isArray(deals) ? deals : [];
}

export async function getDeal(dealId) {
  return getData(`${BASE_URL}/deals/${dealId}`, "Failed to fetch Deal");
}

export async function getContract(contractId) {
  return getData(`${BASE_URL}/contracts/${contractId}`, "Failed to fetch Contract");
}
